export default [
  {
    path: '/:locale([en/]*)?/sustainability',
    name: 'Sustainability',
    component: () => import('@/views/sustainability/Index'),
    meta: {
      // scroll: true,
      // language: false,
      sitemap: {
        loc: '/sustainability'
      }
    },
    redirect: { name: 'sustainability-happiness' },
    children: [
      {
        path: 'happiness',
        name: 'sustainability-happiness',
        component: () => import('@/views/sustainability/happiness/Index'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Sustainability',
          sitemap: {
            loc: '/sustainability/happiness'
          }
        },
      },
      {
        path: 'together/:category?',
        name: 'sustainability-together',
        component: () => import('@/views/sustainability/together/Index'),
        meta: {
          // scroll: true,
          // language: false,
          language: false,
          // parent: 'Sustainability',
          sitemap: { ignoreRoute: true }
        },
      },
      {
        path: 'responsibility',
        name: 'sustainability-responsibility',
        component: () => import('@/views/sustainability/responsibility/Index'),
        meta: {
          // scroll: true,
          // language: false,
          // parent: 'Sustainability',
          sitemap: {
            loc: '/sustainability/responsibility'
          }
        },
      }
    ]
  },
  {
    path: '/:locale([en/]*)?/sustainability/together/:category?/detail/:writingId(\\d+)?',
    name: 'sustainability-together-detail',
    component: () => import('@/views/sustainability/together/Detail'),
    meta: {
      language: false,
      // parent: 'Sustainability',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/:locale([en/]*)?/sustainability/ethical',
    name: 'ethicalPage',
    component: () => import('@/views/sustainability/responsibility/EthicalPage'),
    meta: {
      // scroll: true,
      // language: false,
      sitemap: {
        loc: '/sustainability'
      }
    },
  },
]
